import { HttpClient } from '@/data/protocols/http'
import { RemoteUserProfileAssessment } from '@/data/usecases/profile-assessment/remote-user-profile-assessment'
import { UserProfileAssessment } from '@/domain/usecases/profile-assessment/user-profile-assessment'
import { GenericResponse } from '@/infra/http/generic-response'
import { makeApiV2Url, makeHttpAuthClient } from '../../http'
import { QueryClient } from '@tanstack/react-query'

export const makeRemoteUserProfileAssessment = (
  queryClient: QueryClient
): UserProfileAssessment => {
  return new RemoteUserProfileAssessment(
    queryClient,
    makeApiV2Url('/user/profile-assessment'),
    makeHttpAuthClient() as HttpClient<GenericResponse<UserProfileAssessment.Model>>
  )
}
